import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../store";
import { fetchConsultant } from "./consultant-slice";
import { ENTITY_CONSULTANT } from "../../utils/Constants";
import { getEntityIcon } from "../../utils/Helpers";
import Icon from "../../blocks/Icon";
import { makeStyles, mergeClasses, Text } from "@fluentui/react-components";
import { themeTokens, useGlobalStyles } from "../../utils/Theming";

const useStyles = makeStyles({
  container: {
    textAlign: "left",
    padding: themeTokens.spacingHorizontalXL,
    backgroundColor: themeTokens.colorNeutralBackground2,
  },
  wrapper: {
    display: "flex",
    alignItems: "center",
    gap: themeTokens.spacingHorizontalM,
    width: "100%",
  },
  info: {
    flexGrow: 1,
    overflow: "hidden",
  },
  heading: {
    marginTop: 0,
  },
  email: {
    color: themeTokens.colorNeutralForeground1,
  },
});

const ConsultantPage = () => {
  const styles = useStyles();
  const globalStyles = useGlobalStyles();

  const { uid } = useParams();
  const dispatch: AppDispatch = useDispatch();
  const { consultant, loading } = useSelector((state: RootState) => state.consultant);
  const EntityIcon = getEntityIcon(ENTITY_CONSULTANT, 24);
  
  useEffect(() => {
    if (uid) {
      dispatch(fetchConsultant(uid));
    }
  }, [dispatch, uid]);

  return (
    <>  
      {!loading && consultant && (
        <div className={styles.container}>
          <div className={styles.wrapper}>
            <Icon icon={<EntityIcon />} size="extra-large" />
            <div className={styles.info}>
              <Text
                className={mergeClasses(styles.heading, globalStyles.truncateText)}
                as="h2"
                size={400}
                weight="semibold"
                style={{ margin: 0 }}
                block
              >
                {`${consultant.Person?.firstName || ""} ${consultant.Person?.infix || ""} ${consultant.Person?.lastName || ""}`}
              </Text>
              <Text className={mergeClasses(styles.email, globalStyles.truncateText)} size={300} block>
                {consultant.Person?.emailPrimary}
              </Text>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ConsultantPage;